(function () {
  if (window.__sblInit) return;
  window.__sblInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* 1. Carry the ad's URL parameters onto every button, same as the current page */
    var qs = window.location.search;
    if (qs && qs.length > 1) {
      var extra = new URLSearchParams(qs);
      document.querySelectorAll('a[data-sbl-cta]').forEach(function (a) {
        try {
          var u = new URL(a.getAttribute('href'), window.location.origin);
          extra.forEach(function (v, k) { if (!u.searchParams.has(k)) u.searchParams.set(k, v); });
          a.setAttribute('href', u.toString());
        } catch (e) {}
      });
    }

    /* 2. Sticky bar: slides up after the first scroll and stays */
    var st = document.querySelector('[data-sbl-sticky]');
    if (st) {
      var chk = function () {
        if ((window.scrollY || document.documentElement.scrollTop) > 80) st.classList.add('sbl-on');
      };
      window.addEventListener('scroll', chk, { passive: true });
      chk();
      var offer = document.querySelector('.sbl-offer');
      if (offer && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { st.classList.toggle('sbl-hide', en[0].isIntersecting); }).observe(offer);
      }
    }

    /* 2b. Desktop side panel: rides beside the article, sticks while reading, stops before the closing offer */
    var aside = document.querySelector('[data-sbl-aside]');
    if (aside) {
      var startEl = document.querySelector('.sbl-hero') || document.querySelector('.sbl-story-sec');
      var endEl = document.querySelector('.sbl-close-sec');
      var wrapEl = function () {
        return document.querySelector('.sbl-story-sec .sbl-wrap') || document.querySelector('.sbl-mast-sec > .sbl-wrap');
      };
      var place = function () {
        if (window.innerWidth < 1100) { aside.classList.remove('sbl-aside--on'); return; }
        var w = wrapEl(); if (!w) return;
        var wr = w.getBoundingClientRect();
        aside.style.left = Math.round(wr.right + 20) + 'px';
        var h = aside.offsetHeight, top = 24;
        if (startEl) top = Math.max(24, startEl.getBoundingClientRect().top);
        if (endEl) top = Math.min(top, endEl.getBoundingClientRect().top - h - 24);
        aside.style.top = Math.round(top) + 'px';
        aside.classList.add('sbl-aside--on');
      };
      var raf = 0, req = function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; place(); }); };
      window.addEventListener('scroll', req, { passive: true });
      window.addEventListener('resize', req);
      window.addEventListener('load', place);
      place();
    }

    /* 3. Hero loop: keep muted, play, and hold still for reduced-motion readers */
    document.querySelectorAll('.sbl-hero video').forEach(function (v) {
      v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
      else { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });

    /* 4. Customer row: slow auto-scroll that loops (phones). Swipe pauses it. */
    var row = document.querySelector('[data-sbl-row]');
    if (row && !reduce) {
      var paused = false, timer = null, x = 0;
      var hold = function () {
        paused = true; clearTimeout(timer);
        timer = setTimeout(function () { x = row.scrollLeft; paused = false; }, 2200);
      };
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
        row.addEventListener(ev, hold, { passive: true });
      });
      var tick = function () {
        if (!paused && row.scrollWidth > row.clientWidth + 4 && getComputedStyle(row).display === 'flex') {
          var first = row.querySelector('.sbl-dup .sbl-cc');
          var loopAt = first ? first.offsetLeft - row.querySelector('.sbl-cc').offsetLeft : row.scrollWidth / 2;
          x += 0.35;
          if (x >= loopAt) x -= loopAt;
          row.scrollLeft = x;
        }
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }
  });
})();